/**
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { LookupCollection } from './BaseCollection'
import type { MutationsObject } from '@kp/js-model';

export class Ort extends BaseModel {
    id: number | null = null
    ort: string | null = null
    ort_kurz: string | null = null
    plz: string | null = null
    ordnungsnr_post: number | null = null
    plz_typ: number | null = null
    kanton_id: number | null = null
    land_id: number | null = null

    //vew fields
    kanton_kuerzel: string | null = null
    kanton: string | null = null
    land: string | null = null
    gemeinde_bfs: number | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    get plz_ort() {
        return `${this.plz} ${this.ort}`;
    }

    get plz_ort_gemeinde() {
        return `${this.plz} ${this.ort} (${this.gemeinde_bfs})`;
    }

    getClassName(): string {
        return 'ort';
    }
}

export class OrtCollection extends LookupCollection<Ort> {
    protected modelCls = Ort;
    getModelClassName(): string {
        return 'ort'
    }
}
